import { NavLink } from "react-router-dom"
import imgDashBoard from '../../assets/tableau-de-bord.png' 
import imgObjetBoard from '../../assets/colonne-objets.png'
import imgSettings from '../../assets/parametres-curseurs.png'
import './navdashboard.css'
import plusIcone from '../../assets/carre-plus.png'
import moinsIcone from '../../assets/carre-moins.png'
import { useState,useEffect } from "react"
import addIcon from '../../assets/apps-add.png'
import deletIcon from '../../assets/apps-supprimer.png'
import ViewIcon from '../../assets/jumelles (1).png'
function Navdashboard({handeleAbbObjet,handeleDeletObjet,handeleViewObjet,handeledash}){
    const [objetControl,setObjetControl]= useState(false)
    const changeStateObjet = () => {
        setObjetControl(s => !s)
    }
    const f = () => {
        setObjetControl(false)
    }
    useEffect(
        f
    ,[handeleAbbObjet])
    return <div className="bg-navboard">
        <span to ="/"  className='NavLinkDash' onClick={handeledash}>
            <img src={imgDashBoard} alt="img dash board" />
            <span onClick={handeledash}>
                Tableau de board
            </span> 
                
        </span>
        <span to ="/"  className='NavLinkDash' onClick={changeStateObjet}>
            <img src={imgObjetBoard} alt="img dash board" />
            <span>
                 Objet a contrôlé
            </span>
            {!objetControl ? <img src={plusIcone} alt="icon plus" className="iconToggel" />:<img src={moinsIcone} alt="icon plus" className="iconToggel" />}
        </span>  
            {objetControl ? <div className="objetControl">
                <div className="buttonAdd" onClick={handeleAbbObjet}>
                            <img src={addIcon} alt="add icon" />
                            <input type="button" value="Ajouter un Objet" onClick={handeleAbbObjet}/>
                        </div>
                        <div className="buttonDelet" onClick={handeleDeletObjet}>
                            <img src={deletIcon} alt="delet icon" />
                            <input type="button" value="Supprimer un Objet" onClick={handeleDeletObjet}/>
                        </div>
                        <div className="buttonView" onClick={handeleViewObjet}>
                            <img src={ViewIcon} alt="delet icon" />
                            <input type="button" value="Voir les Objet" onClick={handeleViewObjet}/>
                        </div>
            </div>:null}
        <span to ="/"  className='NavLinkDash'>
            <img src={imgSettings} alt="img dash board" />
            <span>

                Parametre d'administration
            </span>
        </span>
    </div>
}

export default Navdashboard